// ============================================================================
// todo-client-mod -- useGroups Hook
//
// 获取当前用户的分组列表（含 todoCount 统计）。
// ============================================================================
import { useState, useEffect } from 'react';
import { getTodoApiClient } from '../todo-api-client.js';
/**
 * 获取分组列表
 */
export function useGroups() {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchGroups = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await getTodoApiClient().getGroups();
            setGroups(result);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取分组失败';
            setError(message);
            setGroups([]);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchGroups();
    }, []);
    return {
        groups,
        loading,
        error,
        refresh: fetchGroups,
    };
}
//# sourceMappingURL=use-groups.js.map